// al-cart-upsell.js : bouton « + Dodaj » du bloc snippets/al-cart-upsell.liquid (tiroir et page panier).
// Même motif que product-bundle-block.js : un seul POST /cart/add avec les sections du panier
// (cart:grouped-sections), puis l'événement cart-update de Minimog re-rend le tiroir, la page panier,
// la jauge de port offert et les compteurs. Le bloc lui-même est re-rendu, donc recalculé.
if (!customElements.get("al-cart-upsell")) {
  customElements.define(
    "al-cart-upsell",
    class AlCartUpsell extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.addEventListener("click", this.onClick);
      }

      onClick = (e) => {
        const btn = e.target.closest("[data-al-add]");
        if (!btn || btn.disabled) return;
        e.preventDefault();
        this.add(btn);
      };

      add(btn) {
        const { MinimogSettings, MinimogStrings, MinimogTheme, MinimogEvents } = window;
        const sections = [];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections } })
        );
        const config = fetchConfig("javascript");
        config.method = "POST";
        config.body = JSON.stringify({
          items: [{ id: Number(btn.dataset.alAdd), quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        });

        // Mesuré AVANT de désactiver le bouton : un bouton désactivé perd le focus.
        const hadFocus = this.contains(document.activeElement);
        const zoneId = (this.closest("#MinimogCartDrawerBody, #MinimogCartBody") || {}).id;
        btn.disabled = true;
        btn.classList.add("m-spinner-loading");
        fetch(MinimogSettings.routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message || MinimogStrings.cartError);
              return;
            }
            const cartDrawer = document.querySelector("m-cart-drawer");
            if (cartDrawer && MinimogTheme.Notification) {
              MinimogTheme.Notification.show({
                target: cartDrawer.querySelector("m-cart-items"),
                method: "prepend",
                type: "success",
                message: MinimogStrings.itemAdded,
                delay: 400,
              });
            }
            MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: response });
            document.dispatchEvent(new CustomEvent("product-ajax:added", { detail: { product: response } }));
            // Le re-rendu détruit le bouton qui avait le focus : on le rend dans la même zone (clavier,
            // lecteur d'écran), sur le bloc recalculé ou, s'il a disparu, sur la première ligne du panier.
            if (hadFocus && zoneId) {
              const root = document.getElementById(zoneId);
              const target =
                root && (root.querySelector("al-cart-upsell [data-al-add]") || root.querySelector(".m-cart-item a[href]"));
              if (target) target.focus({ preventScroll: true });
            }
            AlCartUpsell.announce(MinimogStrings.itemAdded);
          })
          .catch(() => this.showError(MinimogStrings.cartError || "Error"))
          .finally(() => {
            // Le bloc est normalement remplacé par le re-rendu ; si ce n'est pas le cas, on rend la main.
            btn.disabled = false;
            btn.classList.remove("m-spinner-loading");
          });
      }

      // Région d'annonce unique, hors des zones re-rendues par Minimog.
      static announce(message) {
        if (!message) return;
        let live = document.getElementById("al-cart-upsell-live");
        if (!live) {
          live = document.createElement("div");
          live.id = "al-cart-upsell-live";
          live.setAttribute("role", "status");
          live.setAttribute("aria-live", "polite");
          live.style.cssText = "position:absolute;width:1px;height:1px;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;";
          document.body.appendChild(live);
        }
        live.textContent = "";
        setTimeout(() => (live.textContent = message), 50);
      }

      showError(message) {
        const target = this.querySelector("[data-al-error]");
        if (!target || !window.MinimogTheme.Notification) return;
        window.MinimogTheme.Notification.show({ target, method: "appendChild", type: "warning", message });
      }
    }
  );
}
